"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _locationFinder = _interopRequireDefault(require("./location-finder"));
exports["default"] = _locationFinder["default"];